import { observer } from "mobx-react";
import { useTranslation } from "@/stores/RootStoreContext";
import styles from "./LabelledDivider.module.css";
import { TMessage } from "@/i18n/tt";

export type LabelledDividerProps = {
  label: TMessage;
};

export const LabelledDivider = observer((props: LabelledDividerProps) => {
  const { t } = useTranslation();
  return <div className={styles.labelledDivider}>{t(props.label)}</div>;
});
